import { RequestBuilder } from "../requestBuilder";
import {
  CreateStoredPromptInputSchema,
  StarStoredPromptInputSchema,
  StoredPromptIdParamsSchema,
  StoredPromptSchema,
  StoredPromptsSyncSchema,
  UpdateStoredPromptInputSchema,
} from "./storedPromptClient.types";

export const StoredPromptsSyncRequestConfig = new RequestBuilder({
  path: () => "/stored-prompts-sync",
  responseSchema: StoredPromptsSyncSchema,
}).withIncludeProjectId();

export const CreateStoredPromptRequestConfig = new RequestBuilder({
  path: () => "/stored-prompts",
  responseSchema: StoredPromptSchema,
  bodySchema: CreateStoredPromptInputSchema,
})
  .withMethod("POST")
  .withIncludeProjectId();

export const DeleteStoredPromptRequestConfig = new RequestBuilder({
  paramsSchema: StoredPromptIdParamsSchema,
  path: (params) => `/stored-prompts/${params.id}`,
})
  .withMethod("DELETE")
  .withContentType(undefined)
  .withIncludeProjectId();

export const UpdateStoredPromptRequestConfig = new RequestBuilder({
  paramsSchema: StoredPromptIdParamsSchema,
  path: ({ id }) => `/stored-prompts/${id}`,
  responseSchema: StoredPromptSchema,
  bodySchema: UpdateStoredPromptInputSchema,
})
  .withMethod("POST")
  .withIncludeProjectId();

export const StarStoredPromptRequestConfig = new RequestBuilder({
  paramsSchema: StoredPromptIdParamsSchema,
  path: ({ id }) => `/stored-prompts/${id}/star`,
  responseSchema: StoredPromptSchema,
  bodySchema: StarStoredPromptInputSchema,
})
  .withMethod("POST")
  .withIncludeProjectId();
